import { configureStore } from '@reduxjs/toolkit';
import { productsReducer } from "./Slices/productsSlice";
import { userReducer } from './Slices/userSlices';
import { cartReducer } from './Slices/cartSlice';
import { responseReducer } from './Slices/responseSlice';

const store = configureStore({
    reducer: {
        products: productsReducer,
        user: userReducer,
        cart: cartReducer,
        response: responseReducer,
    },
});
export default store;


